export const encontroTipoEnum = {
  presencial: 1,
  remoto: 2,
  hibrido: 3,
  escritorio: 4,
};
